import { resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return _withDirectives((_openBlock(), _createBlock(_component_router_view, null, null, 512)), [
    [_vShow, _ctx.isReady]
  ])
}